var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelimiter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 12,
    fill: "#6f29a3",
    viewBox: "0 0 1 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0.5 0a0.5 0.5 0 0 0-0.5 0.5v11a0.5 0.5 0 0 0 0.5 0.5 0.5 0.5 0 0 0 0.5-0.5v-11a0.5 0.5 0 0 0-0.5-0.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelimiter);
export default __webpack_public_path__ + "static/media/icon_delimiter.cffee0d71e6b4a6cf8b366826e948dac.svg";
export { ForwardRef as ReactComponent };